import { ITheme } from '@commandbar/internal/client/theme';
import { State } from '../../store';

export const getIconSize = (_: State, theme: ITheme) => {
  const isGridOption = _.searchFilter && _.searchFilter.renderAs === 'grid';
  return isGridOption ? theme.menuGridOption.iconSize : theme.option.iconSize;
};
